import { Stack } from '@mui/material';
import { forwardRef } from 'react';

export default forwardRef((props, ref) => {
    return <Stack ref={ref} {...props} />;
});
